import type { ReactNode } from "react";

import { CcSanjayaEyebrow } from "@/components/ui/CcSanjayaEyebrow";

type CcSliderResultsCalculatorLayoutProps = {
  /** When false, skip the in-layout header (section already has H2 + lead). */
  showHeader?: boolean;
  eyebrow?: string;
  title?: string;
  text?: string;
  controls: ReactNode;
  results: ReactNode;
};

/** v2 traffic/ROI calculator: centered header, sliders left, results panel right. */
export function CcSliderResultsCalculatorLayout({
  eyebrow = "",
  title = "",
  text = "",
  showHeader = true,
  controls,
  results,
}: CcSliderResultsCalculatorLayoutProps) {
  return (
    <>
      {showHeader && title ? (
        <header className="cc-traffic__header">
          {eyebrow ? (
            <CcSanjayaEyebrow theme="on-subtle">{eyebrow}</CcSanjayaEyebrow>
          ) : null}
          <h3 className="cc-traffic__title">{title}</h3>
          {text ? <p className="cc-traffic__text">{text}</p> : null}
        </header>
      ) : null}
      <div className="cc-traffic__columns" data-analytics-tool="roi_calculator">
        <div className="cc-traffic__side">
          <div className="cc-traffic__stack">{controls}</div>
        </div>
        <div className="cc-traffic__panel cc-traffic__panel--results">{results}</div>
      </div>
    </>
  );
}
